import FieldTypesEnum from "../Enums/FieldTypesEnum";
import React from "react";
import FigmaBadge from "../Elements/FigmaBadge";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";
import ShowNameComponent from "../Elements/ShowNameComponent";
import ProjectService from "../Services/projectService";

class SurveyItemList
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.SurveyId = "";
      this.Name = "";
      this.SassieId = "";
      this.IsUninvoiceable = "";
      this.ClientId = "";
      this.SurveyType = "";
      return;
    }
    this.SurveyId = item.surveyId;
    this.Name = item.name;
    this.SassieId = item.sassieId;
    this.IsUninvoiceable = item.isUninvoiceable;
    this.ClientId = item.clientId;
    this.SurveyType = item.surveyType;
  }

  static NameOfTheIdField ()
  {
    return "SurveyId";
  }

  static editGeneralFunction = (id, user, userList) =>
  {
    alert("Empty function");
  };

  static nameOfTheItemDetailList ()
  {
    return "Name";
  }

  static MoneyFields = [];

  static Currency ()
  {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return "";
  }

  static DateFields = [];
  static BoolFields = [ "IsUninvoiceable" ];
  static FieldsToShowInListTable = [];
  static FieldsToShowInDataTable ()
  {
    return [
      {
        label: "Survey Id",
        orderById: "SurveyId",
        data: "SurveyId",
        minWidth: 40
      },
      { label: "Name", orderById: "Name", data: "Name" },
      { label: "Sassie Id", orderById: "SassieId", data: "SassieId" },
      {
        label: "Is Uninvoiceable?",
        orderById: "IsUninvoiceable",
        data: item => SurveyItemList.getBadge(item.IsUninvoiceable)
      },
      { label: "Survey Type", orderById: "SurveyType", data: "SurveyType" },
      {
        label: "Current Projects",
        data: item => (
          <ShowNameComponent
            serviceFunction={id =>
              ProjectService.getProjectNames(id, "current")
            }
            id={item.SurveyId}
          />
        )
      },
      {
        label: "Past/Future Projects",
        data: item => (
          <ShowNameComponent
            serviceFunction={id =>
              ProjectService.getProjectNames(id, "pastfuture")
            }
            id={item.SurveyId}
          />
        )
      },
      {
        label: " ",
        orderById: "",
        data: SurveyItemList.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: "text-center"
      }
    ];
  }

  static editFunction = (id, item, itemList) =>
  {
    alert("Empty function");
  };

  static removeFunction = (id, item, itemList) =>
  {
    alert("Empty function");
  };

  static getBadge (item)
  {
    return item ? (
      <div>
        <FigmaBadge Active={false} InactiveText="True" />
      </div>
    ) : (
      <div>
        <FigmaBadge Active={true} ActiveText="False" />
      </div>
    );
  }

  static getActionsContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: "fa-solid fa-edit",
            text: "Edit",
            onClick: () => SurveyItemList.editFunction(item.SurveyId, item),
            roleKey: "ClientContact_faicon_CreateEdit"
          },
          {
            iconName: "fa-regular fa-trash-can",
            text: "Remove",
            onClick: () => SurveyItemList.removeFunction(item.SurveyId, item),
            roleKey: "ClientContact_faicon_CreateEdit"
          }
        ]}
      />
    );
  }
}

export default SurveyItemList;
